import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 数据处理中心查询接口
export const getListApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/page', // 非权限控制
        method: 'post',
        data
    });
};

// 数据处理中心列表单条数据删除
export const deleteApi = (id) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/deleteById?id=' + id,
        method: 'get'
    });
};

// 数据处理中心列表文件数据删除
export const deleteFileApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/file/delete',
        method: 'post',
        data: data
    });
};

// 数据处理中心列表导出接口
export const getListExportApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/export', // 非权限控制
        method: 'post',
        data
    });
};

// 数据处理中心列表单个对应数据导出接口
export const getRowExportApi = (data) => {
    return request({
        url: '/api-lcp-report/report/task/export', // 非权限控制
        method: 'post',
        data
    });
};

// 数据处理中心保存接口
export const saveApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/save', // 非权限控制
        method: 'post',
        data
    });
};

// 数据处理中心列表单条数据删除
export const verityApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/pullData',
        method: 'post',
        data
    });
};

// 导入文件校验-xsh
export const importCheckApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/importCheck',
        method: 'post',
        data
    });
};
